import { NAV_WIDTH } from "../../../../constants";

export const styles: Record<string, React.CSSProperties> = {
  container: {
    width: NAV_WIDTH,
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },
  header: {
    width: "100%",
    marginRight: 40,
    minHeight: 40,
    marginTop: 10,
  },
  navItemsContainer: {
    width: "100%",
    marginRight: 56,
    minHeight: 40,
  },
};
